import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';
import Education from './education';
import Experience from './experience';
import Skills from './skills';

class Resume extends Component {
    render() {
        return (
            <div>
                <Grid>
                    <Cell col={4}>
                        <div style={{ textAlign: 'center' }}>
                            <img
                                src="https://cdn2.iconfinder.com/data/icons/avatar-2/512/Fred_man-512.png"
                                alt="avatar"
                                style={{ height: '200px' }}
                            />
                        </div>

                        <h2 style={{ paddingTop: '2em' }}>Hardikkumar Vasoya</h2>
                        <h4 style={{ color: 'grey' }}>Full Stack Developer</h4>

                        <hr style={{ borderTop: '3px solid #833fb2', width: '50%' }} />

                        <p>I'm well qualified full-stack web developer having experience in developing quality Websites And Mobile Applications. I want to be associated with an industry where I can get a chance to showcase my experience and skills and contribute to the achievement of the personal and industrial goals.</p>

                        <hr style={{ borderTop: '3px solid #833fb2', width: '50%' }} />

                        <h5>Address</h5>
                        <p>Vancouver, BC, V5X 2L6</p>

                        <h5>Phone</h5>
                        <p>+1(587) 839 XXXX</p>

                        <h5>Email</h5>
                        <p>hjvasoya009@gmail.com</p>

                        <h5>Web</h5>
                        <p>hjvasoya.websterinfotech.com</p>
                    </Cell>
                    <Cell className="resume-right-col" col={8}>
                        <h2>Education</h2>

                        <Education startYear={2020} endYear={2021} instituteName="Langara College" degree="Post-Degree Diploma - Web and Mobile Application Development" />

                        <Education startYear={2009} endYear={2012} instituteName="Sutex Bank College of Computer Application & Science" degree="Bachelors - Bachelor of Computer Applications" />

                        <hr style={{ borderTop: '3px solid #e22947' }} />

                        <h2>Experience</h2>

                        <Experience startYear={2016} endYear={2019} position="Web Developer" companyName="Freelancer" />

                        <Experience startYear={2012} endYear={2016} position="IT Manager" companyName="Soham Group" />

                        <hr style={{ borderTop: '3px solid #e22947' }} />

                        <h2>SKills</h2>

                        <Skills skill="HTML/CSS" progress="100" />
                        <Skills skill="JavaScript" progress="90" />
                        <Skills skill="React" progress="50" />
                        <Skills skill="NodeJS" progress="20" />
                        <Skills skill="PHO" progress="80" />
                        <Skills skill="MySQL" progress="85" />
                    </Cell>
                </Grid>
            </div>
        )
    }
}

export default Resume;